module.exports = __webpack_public_path__ + "assets/img/driver-btn-bf4084a1.png";